// Shared react-toastify options so every screen pops toasts with the same
// timing and behaviour, matching cwclock's Redux/toastOptions.js.
const toastOptions = {
  autoClose: 8000,
  draggable: true,
};

export default toastOptions;
